<template>
    <div class="products_listing">
        <!-- <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading> -->
        <CommonHead></CommonHead>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="mainproduct_listing">
			<h1 class="desktop-hide">All Trimmings</h1>
             <SKLoader
                :repeat="1"
                :loading="isFilterLoading"
                speed="1s"
                >
                <SKProductFilter/>
                </SKLoader>
                <div class="filterbar" v-if="isFilterLoading == false">
				<a @click="togglefilter" class="filtershow" href="#">Filter<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
                    <div class="allfilter">
					<h6>QUICK SEARCH BY</h6>
                    <div class="bookfilter">
                        <h4>Collections</h4>
                        <select-2 url="/shop/api/product-books/trim" v-model="form.booksdrop"  @input="selectCollections()">
                        </select-2>
                    </div>
                    <div class="patternfilter">
                        <h4>Patterns</h4>
                        <select-2 url="/shop/api/product-patterns/trim" v-model="form.patternsdrop"  @input="loadPColors()">
                        </select-2>
                    </div>
                    <div class="patterndesignfilter">
                        <h4>Pattern Colors</h4>
                        <select-2 :url="patternColorDropdownUrl" v-model="form.colorsdrop"  @input="selectColors()" ref="formColorsdrop">
                        </select-2>
                    </div>
                    <div class="filter_by">
                        <h6>Filter By</h6>
                        <ul>
                            <li><a href="javascript:;" v-b-toggle.collapse-design>Pattern Design <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-design" accordion="my-accordion">
                                <ul>
                                    <li v-for="(lp,lpk) in loadPatterns" :key="lpk"><md-checkbox :value="lp.WEBCATEGORYVALUE" v-model="form.patterns" @change="loadFilter(form)">{{lp.WEBCATEGORYVALUE}}</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>
                            <li><a href="javascript:;" v-b-toggle.collapse-color>Color <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-color" accordion="my-accordion">
                                <ul>
                                    <li v-for="(lc,lck) in loadColors" :key="lck"><md-checkbox :value="lc.Colors" v-model="form.colors" @change="loadFilter(form)">{{lc.Colors}}</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>

                            <li><a href="javascript:;" v-b-toggle.collapse-status>Status <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-status" accordion="my-accordion">
                                <ul>
                                    <li v-for="(ls,lsk) in loadStatus" :key="lsk"><md-checkbox :value="ls.PA" v-model="form.status" @change="loadFilter(form)">{{ls.PA}}</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>

                            <li><a href="javascript:;" v-b-toggle.collapse-showroom>Showroom <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-showroom" accordion="my-accordion">
                                <ul>
                                    <li><md-checkbox value="showroom" v-model="form.showroom" @change="loadFilter(form)">Display showroom items</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>
                            <li><a href="javascript:;" v-b-toggle.collapse-sale>Sale <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-sale" accordion="my-accordion">
                                <ul>
                                    <li><md-checkbox value="Sale" v-model="form.sale" @change="loadFilter(form)">Sale</md-checkbox></li>
                                </ul>
                            </b-collapse>
                            </li>
                            <li><a href="javascript:;" v-b-toggle.collapse-price>Price / Yd <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
                            <b-collapse id="collapse-price" accordion="my-accordion">
                                <ul>
                                    <li><RangeSlider v-model="form.price" :min="minprice" :max="maxprice" :format="format" @update="loadFilter(form)" /></li>
                                </ul>
                            </b-collapse>
                            </li>
                        </ul>
                    </div>
					<div class="mobile-category">
					<h4>Category</h4>
                    <ul>
                        <li><router-link to="/shop/products/fabric" :class="[selectedPage.includes('fabric') ? activeClass : '']">Fabrics</router-link></li>
                        <li><router-link to="/shop/products/trim" :class="[selectedPage.includes('trim') ? activeClass : '']">Trimming</router-link></li>
                        <!-- <li><router-link to="/shop/products/hardware" :class="[selectedPage.includes('hardware') ? activeClass : '']">Hardware</router-link></li> -->
                        <li><a href="/hardware-brands/">Hardware</a></li>
                        <li><router-link to="/shop/products/sample" :class="[selectedPage.includes('sample') ? activeClass : '']">Sample</router-link></li>
                    </ul>
					</div>
					</div>
                </div>
                <div class="productsbar">
                    <div class="topsection">
						<h1 class="seo-purpose">All Trimming collection</h1>
                        <h2>All Trimming</h2>
                        <div class="sortby">
                            <label class="sort">Sort By: </label>
                            <v-select
                                :options="sorting"
                                v-model="form.sort"
                                @input="loadFilter"
                                :reduce="sorting => sorting.value"
                                label="text"
                                :clearable="false"
                                :searchable="false"
                                placeholder="Sorting"
                            ></v-select>
                        </div>
                    </div>
                    <div class="productselectedfilter" v-if="(form.patterns.length > 0)||(form.colors.length > 0)||(form.status.length > 0)||(form.showroom.length > 0)||(form.sale.length > 0)">
                        <b-form-tags v-if="form.patterns.length > 0" v-model="form.patterns" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.patterns"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.colors.length > 0" v-model="form.colors" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.colors"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.status.length > 0" v-model="form.status" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.status"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.showroom.length > 0" v-model="form.showroom" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.showroom"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.sale.length > 0" v-model="form.sale" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.sale"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <a class="clearfilter" href="javascript:;" @click="resetFilter">Clear all</a>
                    </div>
                    <div class="mainproducts">
                        <SKLoader :repeat="4*3" :loading="isLoading">
                        <SKProductCard/>
                        </SKLoader>
                        <p v-if="rows == 0">No results found.</p>
                        <div class="productbox" v-for="(lp,lpk) in loadProducts" :key="lpk">
                            <a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="imgbox">
                                <b-img class="proimg" :src="lp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                                <span v-if="lp.DIFFDAYS <= 365" class="newtag">New</span>
                                <span v-if="(lp.DETAIL[0].ABCCODEVALUE != 'A' && lp.DETAIL[0].ABCCODEVALUE != 'B' && lp.DETAIL[0].ABCCODEVALUE != 'C' && lp.DETAIL[0].ABCCODEVALUE != 'D' && lp.DETAIL[0].ABCCODEVALUE != 'E' && lp.DETAIL[0].ABCCODEVALUE != 'F' && lp.DETAIL[0].ABCCODEVALUE != 'X' && lp.DETAIL[0].ABCCODEVALUE != 'L') && lp.DETAIL[0].DISCOUNTPRICE > 0" class="saletag">Sale</span>
                            </a>
                            <div class="contentbox">
                                <div class="smallimages" v-if="lp.DETAIL.length > 0">
                                    <a v-for="(sw,swind) in lp.DETAIL" :key="swind" :href="'/shop/product/'+lp.ITEMID+'/'+sw.INVENTCOLORID" class="forborder" @mouseover="loadswatchdata(sw,lp.ITEMID,sw.INVENTCOLORID,$event)">
                                        <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                    </a>
                                    <a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="forborder" v-if="lp.TOTALSWATCH > 5"><div class="moreprod">+{{lp.TOTALSWATCH - 5}}</div></a>
                                </div>
                                <h4><a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID">{{lp.ITEMNAME}} / <span class="clname">{{lp.DETAIL[0].COLORNAME}}</span></a></h4>
                                <p v-if="lp.DETAIL[0].SHORTDESCRIPTION != ''">{{lp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                <div v-if="lp.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0"><p class="regprice">${{lp.DETAIL[0].PRICE}}</p><span class="saleprice">${{lp.DETAIL[0].DISCOUNTPRICE}}</span></div>
                                <p v-else-if="user.id > 0 && lp.DETAIL[0].DISCOUNTPRICE == 0">${{lp.DETAIL[0].PRICE}}</p>
                                <!--<p v-if="lp.DETAIL[0].ABCCODEVALUE != 'A' && lp.DETAIL[0].ABCCODEVALUE != 'B' && lp.DETAIL[0].ABCCODEVALUE != 'C' && lp.DETAIL[0].ABCCODEVALUE != 'D' && lp.DETAIL[0].ABCCODEVALUE != 'E' && lp.DETAIL[0].ABCCODEVALUE != 'F'">{{lp.DETAIL[0].QTYONHAND}} left</p>-->
                            </div>
                        </div>
                    </div>
                    <div class="propagination" v-if="loadProducts.length>0">
                        <div class="mt-3 custompage">
                            <b-pagination
                                v-model="currentPage"
                                @input="paginationChange"
                                :total-rows="rows"
                                :per-page="perPage"
                                align="center"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                        <div class="itemspage">
                            <label class="pageitem">Items per page :</label>
                            <v-select
                                :options="itemspage"
                                v-model="form.items"
                                @input="loadFilter"
                                :clearable="false"
                                :searchable="false"
                                placeholder="40"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SKProductCard from "@/views/skeletons/SKProductCard";
import SKProductFilter from "@/views/skeletons/SKProductFilter";
import Select2 from './Select2.vue';
import RangeSlider from '@vueform/slider/dist/slider.vue2';
import '@vueform/slider/themes/default.css';

export default {
  components: {
    CommonHead,
    CommonFoot,
    SKProductCard,
    SKProductFilter,
    'v-select': vSelect,
    Loading,
    Select2,
    RangeSlider
  },
  metaInfo: {
    title: 'RM COCO | View All Trimming',
    meta: [{
        name: 'description',
        content: 'Wholesale trimming for every project. Perfect for draperies, bedding, furniture, and pillows.'
    }],
  },
  computed:{
        ...mapGetters(["user"]),
        selectedPage(){
            return this.$route.path;
        }
  },
  mounted(){
        this.isLoading = true;
        this.isFilterLoading = true;
        this.PageloadFilter();
        this.$store.dispatch("loadBooksdrop","trim").then(loadBooksdrop => {
            this.loadBooksdrop = loadBooksdrop.data;
        });
        this.$store.dispatch("loadPatternsdrop","trim").then(loadPatternsdrop => {
            this.loadPatternsdrop = loadPatternsdrop.data;
            this.loadPatternsdropNew = this.loadPatternsdrop.slice(0, this.limit);
        });
        this.$store.dispatch("loadColorsdrop","trim").then(loadColorsdrop => {
            this.loadColorsdrop = loadColorsdrop.data.items;
        });
        this.observer = new IntersectionObserver(this.infiniteScroll);
        if(this.$route.query.designcolor){
            this.form.colorsdrop = this.$route.query.designcolor;
        }
  },
  data(){
      return{
        activeClass:'active',
        loadProducts:[],
        loadColors:{},
        loadPatterns:{},
        loadStatus:{},
        loadBooksdrop: [],
        loadPatternsdrop: [],
        loadColorsdrop: [],
        sritem:{
            cnt_showroom:0
        },
        rows: 40,
        perPage: 40,
        currentPage: 1,
        sorting: [
          { value: 'newest', text: 'Newest'},
          //{ value: 'abccode', text: 'Popularity'},
          { value: 'lowtohigh', text: 'Price: Low to High'},
          { value: 'hightolow', text: 'Price: High to Low'}
        ],
        itemspage: [
           '20','40','100'
        ],
        quantity: 1,
        form:{
            booksdrop:'',
            patternsdrop:'',
            colorsdrop:'',
            colors: [],
            patterns: [],
            status:[],
			showroom:[],
            sale:[],
            price:[1,400],
            items:40,
            sort:'newest',
            page:1
        },
        minprice: 0,
        maxprice: 200,
        format: function (value) {
          return `$${Math.round(value)}`
        },
        isLoading: false,
        isFilterLoading: false,
          breadcrumb: [
          {
            text: 'Home',
            href: '/'
          },
          {
            text: 'Trimming',
            active: true
          }
        ],
        observer: null,
        limit:10,
        search:'',
        hasNextPage:false,
        loadPatternsdropNew:[],
        patternColorDropdownUrl:'/shop/api/product-colors/trim/all',
        oldBooksdrop: "",
      };
  },
  methods: {
		togglefilter(){
            $(".allfilter").toggle();
            $(".filtershow").toggleClass("minusshow");
		},
        paginationChange(page){
            this.form.page = page;
            this.loadFilter();
        },
        selectColors(){
            this.form.booksdrop = '';
            this.selectSelection();
        },
        selectCollections(){
            this.form.patternsdrop = '';
            this.form.colorsdrop = '';
            this.selectSelection();
        },
		loadPColors(){ 
            this.form.booksdrop = "";
            this.form.colorsdrop = "";
            if(this.form.patternsdrop != ''){
                this.patternColorDropdownUrl="/shop/api/product-colors/trim/"+this.form.patternsdrop;
            }else{
                this.patternColorDropdownUrl="/shop/api/product-colors/trim/all";
            }
            var type= this.form.patternsdrop !=''?this.form.patternsdrop:null;
            this.$store.dispatch("isShowRoomByItem",type).then(isShowRoomByItem => {
                if(isShowRoomByItem.data.length > 0 && isShowRoomByItem.data[0].hasOwnProperty('SHOWROOM') && isShowRoomByItem.data[0].SHOWROOM == 1){
                    this.form.showroom[0] = "showroom";
                } else{
                    this.form.showroom = [];
                }
                this.loadFilter();
            });
        },
        selectSelection(){
            this.form.showroom=[];
            if(this.form.booksdrop != null && this.form.booksdrop !=''){
                if (this.form.patternsdrop != '') {
                    this.oldBooksdrop = this.form.booksdrop;
                }
                let bdseleced =  this.loadBooksdrop.items.find(el => el.text == this.form.booksdrop);
                if(bdseleced != undefined){
                    if(bdseleced.showroom == "1"){
                        this.form.showroom=['showroom'];
                    }
                }
            }
            this.form.colors= [];
            this.form.patterns= [];
            this.form.status=[];
            this.form.items=40;
            this.form.page=1; 
            if(this.form.colorsdrop != ""){
                this.$store.dispatch("isShowRoomByColor",this.form.colorsdrop).then(isShowRoomByColor => {
                    if(isShowRoomByColor.data.length > 0 && isShowRoomByColor.data[0].hasOwnProperty('SHOWROOM') && isShowRoomByColor.data[0].SHOWROOM == 1){
                        this.form.showroom[0] = "showroom";
                    } else{
                        this.form.showroom = [];
                    }
                    this.loadFilter();
                });
            }else{
                this.loadFilter();
            }
            
        },
        loadFilter(){
            this.isLoading = true;
            this.isFilterLoading = false;
            this.loadProducts = [];
            let url = [];
            if(this.form.booksdrop != ''){
                url["book"] = this.form.booksdrop;
            }
            if(this.form.patternsdrop != ''){
                url["design"] = this.form.patternsdrop;
            }
            if(this.form.colorsdrop != ''){
                url["designcolor"] = this.form.colorsdrop;
            }

            if(this.form.colors.length > 0){
                url["color"] = this.form.colors.join();
            }
            if(this.form.patterns.length > 0){
                url["pattern"] = this.form.patterns.join();
            }

			if(this.form.status.length > 0){
                url["status"] = this.form.status.join();
            }
			if(this.form.showroom.length > 0){
                url["showroom"] = this.form.showroom.join();
            }
            if(this.form.sale.length > 0){
                url["sale"] = this.form.sale.join();
            }
            if(this.form.price.length > 0){
                url["price"] = this.form.price.join();
            }
            if(this.form.items != null){
                url["items"] = this.form.items;
            }
            if(this.form.sort != null){
                url["sort"] = this.form.sort;
            }
            url["page"] = this.form.page;
            this.$router.push({query: url });

            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadtrimProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		PageloadFilter(){
            let url = [];
            if(this.$route.query.book){
                url["book"] = this.$route.query.book;
            }
            if(this.$route.query.design){
                url["design"] = this.$route.query.design;
                this.patternColorDropdownUrl="/shop/api/product-colors/trim/"+url["design"];
            }
            if(this.$route.query.designcolor){
                url["designcolor"] = this.$route.query.designcolor;
            }
            if(this.$route.query.type){
				url["type"] = this.$route.query.type;
				this.$root.$emit('bv::toggle::collapse', 'collapse-type');
			}
            if(this.$route.query.color){
				url["color"] = this.$route.query.color;
				this.$root.$emit('bv::toggle::collapse', 'collapse-color');
			}
            if(this.$route.query.pattern){
				url["pattern"] = this.$route.query.pattern;
				this.$root.$emit('bv::toggle::collapse', 'collapse-design');
			}
            if(this.$route.query.passes){
				url["passes"] = this.$route.query.passes;
				this.$root.$emit('bv::toggle::collapse', 'collapse-passes');
			}
            if(this.$route.query.use){
				url["use"] = this.$route.query.use;
				this.$root.$emit('bv::toggle::collapse', 'collapse-use');
			}
			if(this.$route.query.status){
				url["status"] = this.$route.query.status;
				this.$root.$emit('bv::toggle::collapse', 'collapse-status');
			}
			if(this.$route.query.showroom){
                url["showroom"] = this.$route.query.showroom;
				this.$root.$emit('bv::toggle::collapse', 'collapse-showroom');
            }
            if(this.$route.query.sale){
                url["sale"] = this.$route.query.sale;
				this.$root.$emit('bv::toggle::collapse', 'collapse-sale');
            }
            if(this.$route.query.price){
                url["price"] = this.$route.query.price;
            }
            if(this.$route.query.items){
                url["items"] = this.$route.query.items;
            }else{
                url["items"] = this.form.items;
            }
            if(this.$route.query.sort){
                url["sort"] = this.$route.query.sort;
            }else{
                url["sort"] = this.form.sort;
            }
            if(this.$route.query.page){
                url["page"] = this.$route.query.page;
                this.form.page = this.$route.query.page;
            }else{
                url["page"] = this.form.page;
            }

            this.$router.push({query: url });

            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.triminfowithcount(queryString);
            this.$store.dispatch("loadtrimProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.minprice = loadProducts.data.minprice;
                this.maxprice = loadProducts.data.maxprice;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
                this.isFilterLoading = false;
            });
			this.AciveFilter();
        },
		AciveFilter(){
            if(this.$route.query.book){
				this.form.booksdrop=this.$route.query.book;
            }
            if(this.$route.query.design){
				this.form.patternsdrop=this.$route.query.design;
            }
            if(this.$route.query.designcolor){
				this.form.colorsdrop=this.$route.query.designcolor;
            }
            if(this.$route.query.color){
				this.form.colors=this.$route.query.color.split(',');
			}
			if(this.$route.query.pattern){
				this.form.patterns=this.$route.query.pattern.split(',');
			}
			if(this.$route.query.status){
				this.form.status=this.$route.query.status.split(',');
			}
			if(this.$route.query.showroom){
				this.form.showroom=this.$route.query.showroom.split(',');
            }
            if(this.$route.query.sale){
				this.form.sale=this.$route.query.sale.split(',');
            }
            if(this.$route.query.price){
				this.form.price=this.$route.query.price.split(',');
            }
            if(this.$route.query.items){
			    this.form.items=this.$route.query.items;
			}
            if(this.$route.query.sort){
			    this.form.sort=this.$route.query.sort;
			}
        },
        triminfowithcount(queryString){
            this.$store.dispatch("loadtrimFilters",queryString).then(loadtrimFilters => {
                this.loadColors = loadtrimFilters.colors;
                this.loadPatterns = loadtrimFilters.patterns;
                this.loadStatus = loadtrimFilters.status;
                this.sritem = loadtrimFilters.showroom;
            });
        },
        refreshTag(tag){
            setTimeout(function () { this.loadFilter() }.bind(this), 500);
        },
        resetFilter(){
            this.form.booksdrop = "";
            this.form.patternsdrop = "";
            this.form.colorsdrop = "";
            this.form.colors= [];
            this.form.patterns= [];
            this.form.status=[];
			this.form.showroom=[];
            this.form.sale=[];
            this.form.price = [1,400];
            this.form.items=40;
            this.form.sort='newest';
            this.form.page=1;
            this.loadFilter();
        },
        loadswatchdata(detail,itemid,inventcolorid,event){
            $(".productbox .imgbox").removeClass("active");
            $(event.target).parents(".productbox").children(".imgbox").addClass("active");
            let buildurl = '/shop/product/'+itemid+'/'+inventcolorid;
            let hoverimg = detail.MEDIUM_IMAGE;
            let colornamehvr = detail.COLORNAME
            $(event.target).parents(".productbox").children(".imgbox").attr("href",buildurl);
            $(event.target).parents(".productbox").children(".imgbox").children(".proimg").attr("src",hoverimg);
            $(event.target).parents(".contentbox").children("h4").children("a").attr("href",buildurl);
            $(event.target).parents(".contentbox").children("h4").children("a").children(".clname").text(colornamehvr);
        },
        async infiniteScroll ([{isIntersecting, target}]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 10;
                this.loadPatternsdropNew = this.loadPatternsdrop.slice(0, this.limit);
                await this.$nextTick();
                ul.scrollTop = scrollTop;
            }
        },
        async onOpen () {
            let vm=this;
            vm.hasNextPage = vm.loadPatternsdrop.filter(pattern => pattern.includes(vm.search)).length > vm.loadPatternsdropNew.filter(pattern => pattern.includes(vm.search)).slice(0, vm.limit).length;
            if (vm.hasNextPage) {
                await vm.$nextTick();
                vm.observer.observe(vm.$refs.load)
            }
        },
        onClose () {
            this.observer.disconnect();
        },
        searchFun(s){
            if(s.length > 0){
                axios.get(`/shop/api/product-patterns/trim/`+s).then(response => {
                    this.loadPatternsdrop= response.data;
                    this.loadPatternsdropNew = response.data;
                });
            }else{
                this.$store.dispatch("loadPatternsdrop","trim").then(loadPatternsdrop => {
                    this.loadPatternsdrop = loadPatternsdrop.data;
                    this.loadPatternsdropNew = this.loadPatternsdrop.slice(0, this.limit);
                    return;
                });
            }
        },
        getPatternColorUrl(){
            if(this.form.patternsdrop){
                return "/shop/api/product-colors/trim/"+this.form.patternsdrop;
            }else{
                return "/shop/api/product-colors/trim/all";
            }
        }
    }
};
</script>
<style>

</style>